(() => {
  function initialize(root) {
    root.querySelectorAll('.content-newsletter__form').forEach(form => {
      const progress = form.querySelector('[data-newsletter-progress]');
      const button = form.querySelector('button[type="submit"]');
      if (!progress || !button || form.dataset.newsletterFeedbackBound) return;
      form.dataset.newsletterFeedbackBound = 'true';
      let timer = null;

      function reset() {
        clearTimeout(timer);
        timer = null;
        button.removeAttribute('aria-busy');
        progress.hidden = true;
        progress.textContent = '';
      }

      function showProgress() {
        if (!form.checkValidity() || timer !== null) return;
        button.setAttribute('aria-busy', 'true');
        progress.hidden = false;
        progress.textContent = progress.dataset.checkingMessage;
        timer = setTimeout(() => {
          timer = null;
          button.removeAttribute('aria-busy');
          progress.textContent = progress.dataset.waitingMessage;
        }, 20000);
      }

      button.addEventListener('click', showProgress, true);
      form.addEventListener('submit', showProgress, true);
      form.addEventListener('input', () => { if (timer === null) reset(); });
      window.addEventListener('pageshow', event => { if (event.persisted) reset(); });
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
